import { useMachine } from '@xstate/react';
import React from 'react';
import { Interpreter, State } from 'xstate';
import {
  ViewRFIContext,
  ViewRFIEvents,
  ViewRFIStateMachine,
  ViewRFIStates,
} from './viewRfiMachineTypes';

type ViewRFIMachineProviderProps = {
  children: React.ReactNode;
  viewRfiMachine: ViewRFIStateMachine;
};

type ViewRFIMachineState = State<ViewRFIContext, ViewRFIEvents, ViewRFIStates>;

type ViewRFIMachineService = Interpreter<
  ViewRFIContext,
  ViewRFIStates,
  ViewRFIEvents
>;

type ViewRFIMachineContextValue = {
  viewRfiMachineState: ViewRFIMachineState;
  viewRfiMachineService: ViewRFIMachineService;
};

const ViewRFIMachineContext =
  React.createContext<ViewRFIMachineContextValue | null>(null);

const ViewRFIMachineProvider: React.FC<ViewRFIMachineProviderProps> = ({
  children,
  viewRfiMachine,
}) => {
  const [viewRfiMachineState, , viewRfiMachineService] =
    useMachine(viewRfiMachine);

  return (
    <ViewRFIMachineContext.Provider
      value={{ viewRfiMachineState, viewRfiMachineService }}
    >
      {children}
    </ViewRFIMachineContext.Provider>
  );
};

export {
  ViewRFIMachineProvider,
  ViewRFIMachineContext,
  ViewRFIMachineContextValue,
};
